import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="scroll-mt-20 mx-auto max-w-[1440px] px-4 py-24 sm:px-6 lg:px-10 lg:py-32" data-id="element-130" data-mp="oiduju285uda">
      <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-24" data-id="element-131" data-mp="jj18vcn3atca">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-132" data-mp="emtzf9vhizpl">
          <h2 className="text-4xl font-semibold leading-[1.04] tracking-tightest text-ink sm:text-5xl lg:text-[56px]" data-id="element-133" data-mp="akpb8qnt2vac">
            Veelgestelde <span className="text-ink-muted" data-id="element-134" data-mp="5m5kmcy9ovbn">vragen</span>
          </h2>
          <p className="mt-5 max-w-sm text-lg text-ink-soft" data-id="element-135" data-mp="mswzpzknk80">
            Staat je vraag er niet tussen? Bel ons op{' '}
            <a href="tel:0850000000" className="font-medium text-ink underline underline-offset-4" data-id="element-136" data-mp="1zyc562d1wogm">085 – 000 00 00</a>.
          </p>
        </div>
        <div className="border-t border-line" data-id="element-137" data-mp="1uyhiyc480n1w">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="border-b border-line" data-id="element-138" data-mp="1ritfkigdwt7p" data-mpi={i}>
                <h3 data-id="element-139" data-mp="1dis6wgtvohho">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left text-[18px] font-medium text-ink" data-id="element-140" data-mp="1djbmhqw22tsj">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-141" data-mp="1whxod7zecoxi" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-142" data-mp="2p48pcjqx0ruu">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-143" data-mp="2tymn2st1vb2o">
                      <p className="max-w-2xl pb-6 text-[16px] leading-relaxed text-ink-soft" data-id="element-144" data-mp="2psptuj7oydsp">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}